// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"640":"782765d2","2419":"782765d2","3267":"292ae22a","5345":"782765d2","8655":"782765d2","9221":"782765d2"}[chunkId] + ".chunk.css";
};